export const validateGroupName = (name: string) => {
  switch (name) {
    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'
    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'
    case 'categoriasIds':
      return 'categoriaCompacta'
    case 'categoriasSelectIds':
      return 'categoriaCompacta'
    case 'anoIds':
      return 'ano'
    case 'anosSelectIds':
      return 'ano'
    case 'mesesIds':
      return 'mes'
    case 'mesesSelectIds':
      return 'mes'
    case 'historicoIds':
      return 'historico'
    case 'historicoSelectIds':
      return 'historico'
    case 'operacaoIds':
      return 'operacao'
    case 'operacaoSelectIds':
      return 'operacao'
    default:
      return null
  }
}
